(function () {
  // Order / Pre-order Number requirement.
  //
  // Table 1 is always required, so its Order # is marked required directly in
  // the theme template (no JS needed there).
  //
  // Tables 2-5 are optional as a whole -- a customer booking one table leaves
  // them blank -- so we can't hard-require their Order #, or those blank
  // optional tables would block checkout. Instead, a table's Order # becomes
  // required only once that table is actually being used, i.e. once the
  // customer has typed an author/vendor name into it. Mirrors the existing
  // insurance-declared-value-required.js conditional-required pattern.
  function wire(n) {
    var nameField = document.querySelector('[name="properties[Table ' + n + ' Name]"]');
    var orderField = document.querySelector('[name="properties[Table ' + n + ' Order #]"]');
    if (!nameField || !orderField) return;

    function applyRequired() {
      orderField.required = nameField.value.trim() !== '';
    }

    applyRequired();
    nameField.addEventListener('input', applyRequired);
  }

  function init() {
    for (var n = 2; n <= 5; n++) {
      wire(n);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
